import { Button } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import { LucideCheckSquare, LucideTrash2, LucideX } from 'lucide-react';

import { useTranslations } from '../../i18n/useTranslations';

import { $sidebarWidth } from '~/app/state/sidebar.state';

type PricingBulkToolbarProps = {
  selectedCount: number;
  onDelete: () => void;
  onSelectAll: () => void;
  onClearSelection: () => void;
};

export const PricingBulkToolbar = ({
  selectedCount,
  onDelete,
  onSelectAll,
  onClearSelection,
}: PricingBulkToolbarProps) => {
  const t = useTranslations();
  const sidebarWidth = useAtomValue($sidebarWidth) ?? 216;

  if (selectedCount === 0) return null;

  return (
    <div
      className="@PricingBulkToolbar pointer-events-none fixed right-0 bottom-20 z-40 flex flex-col items-center"
      style={{ left: sidebarWidth }}
    >
      <div className="pointer-events-auto flex items-center gap-2 rounded bg-neutral px-3 py-2 text-sm text-white shadow-lg">
        <span>
          {selectedCount} {t.common.selected}
        </span>
        <Button
          variant="ghost"
          color="neutral"
          icon={<LucideCheckSquare size={14} />}
          onPress={onSelectAll}
        >
          {t.pricing.bulk.selectAll}
        </Button>
        <Button
          variant="solid"
          color="failure"
          icon={<LucideTrash2 size={14} />}
          onPress={onDelete}
        >
          {t.common.actions.delete}
        </Button>
        <button
          className="flex size-6 items-center justify-center rounded text-white/70 hover:text-white"
          onClick={onClearSelection}
        >
          <LucideX size={14} />
        </button>
      </div>
    </div>
  );
};
